import React from "react";
import { CtaStrategy } from "../../config/CtaStrategyConfig";
import "./styles/GuestCta.css";

interface GuestCtaProps {
  cta: CtaStrategy;
  onLoginClick: () => void;
}

const GuestCta: React.FC<GuestCtaProps> = ({ cta, onLoginClick }) => (
  <div className="guestcta__section">
    <div className="guestcta__card">
      <h2 className="guestcta__heading">Almost There</h2>
      <p className="guestcta__desc">
        Login or create an account in seconds — we promise no spamming!
      </p>
      <button className="guestcta__btn" onClick={onLoginClick}>
        {cta.guestLabel}
      </button>
    </div>
  </div>
);

export default GuestCta;
